"use strict";

var _slicedToArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var react_id_generator_1 = tslib_1.__importDefault(require("react-id-generator"));

var __1 = require("../../..");

var styles = tslib_1.__importStar(require("./HorizontalLodgingCard.style"));

var PriceInfo_1 = tslib_1.__importDefault(require("../../PriceInfo"));

function HorizontalLodgingCard(_ref) {
  var className = _ref.className,
      id = _ref.id,
      title = _ref.title,
      imgSrc = _ref.imgSrc,
      thumbnailSrc = _ref.thumbnailSrc,
      stickers = _ref.stickers,
      rating = _ref.rating,
      priceDetail = _ref.priceDetail,
      caption = _ref.caption,
      hasVideo = _ref.hasVideo,
      unAvailableReason = _ref.unAvailableReason,
      _ref$isWished = _ref.isWished,
      isWished = _ref$isWished === void 0 ? false : _ref$isWished,
      _ref$onClick = _ref.onClick,
      _onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      onClickIsWished = _ref.onClickIsWished,
      onClickIsNotWished = _ref.onClickIsNotWished;

  var containerRef = react_1.useRef(null);

  var _react_1$useState = react_1.useState(isWished),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      isWishedState = _react_1$useState2[0],
      setWished = _react_1$useState2[1];

  function handleClickWish() {
    if (isWishedState) {
      onClickIsNotWished && onClickIsNotWished(id, setWished);
      return;
    }

    onClickIsWished && onClickIsWished(id, setWished);
  } // 콘텐츠 영역의 스티커는 숙소 영상 제외, NEW는 앞으로 배치


  var contentStickers = stickers ? stickers.sort(function (a, b) {
    if (a.name === __1.DEFINE_STICKER_NAMES.NEW) {
      return -1;
    }

    return b.name === __1.DEFINE_STICKER_NAMES.NEW ? 1 : 0;
  }).map(function (stickerProps) {
    return jsx_runtime_1.jsx(__1.Sticker, Object.assign({}, stickerProps, {
      size: "small"
    }), react_id_generator_1.default());
  }) : undefined;
  return jsx_runtime_1.jsxs("div", Object.assign({
    ref: containerRef,
    css: styles.container,
    className: className,
    onClick: function onClick() {
      return _onClick(id);
    }
  }, {
    children: [jsx_runtime_1.jsxs("div", Object.assign({
      css: styles.imgTagContainer
    }, {
      children: [jsx_runtime_1.jsx(__1.ResponsiveImage, {
        css: styles.imgWrapper,
        src: imgSrc[0],
        placeholderSrc: thumbnailSrc,
        alt: "thumbnail"
      }, void 0), hasVideo && jsx_runtime_1.jsx("div", Object.assign({
        css: styles.videoWrapper
      }, {
        children: jsx_runtime_1.jsx(__1.Sticker, Object.assign({}, __1.DEFINE_STICKERS.VIDEO, {
          size: "small"
        }), void 0)
      }), void 0)]
    }), void 0), jsx_runtime_1.jsxs("div", Object.assign({
      css: styles.content.root
    }, {
      children: [jsx_runtime_1.jsx("div", Object.assign({
        css: styles.content.title
      }, {
        children: title
      }), void 0), contentStickers && jsx_runtime_1.jsx("div", Object.assign({
        css: styles.content.stickerContainer
      }, {
        children: contentStickers
      }), void 0), jsx_runtime_1.jsx("div", Object.assign({
        css: styles.reviewContainer
      }, {
        children: (rating === null || rating === void 0 ? void 0 : rating.reviewCount) ? jsx_runtime_1.jsx(__1.RatingStarGrade, {
          size: "small",
          rating: rating.ratingValue,
          reviewCount: rating.reviewCount
        }, void 0) : jsx_runtime_1.jsx(__1.ReviewEvent, {}, void 0)
      }), void 0), jsx_runtime_1.jsx(PriceInfo_1.default, {
        css: styles.priceInfoWrapper,
        salePrice: priceDetail.salePrice,
        originPrice: priceDetail.originPrice,
        discountRate: priceDetail.discountRate,
        caption: caption,
        isReservable: priceDetail.isReservable,
        unAvailableReason: unAvailableReason
      }, void 0)]
    }), void 0), jsx_runtime_1.jsx(__1.WishlistIcon, {
      css: styles.wishlistWrapper,
      isGray: true,
      isWished: isWishedState,
      onClick: handleClickWish
    }, void 0)]
  }), void 0);
}

exports.default = react_1.memo(HorizontalLodgingCard);